<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.menu.approve.trucker.label.title')}}</h4>
                            </div>
                        </div>
                    </div>

                    <!-- Form row -->
                    <div class="row" v-if="data._id">
                        <div class="col-md-12">
                            <div class="card-box">
                                <form>
                                    <div v-if="data._id" class="form-row" >
                                        <div class="form-group col-md-3">
                                            <label  for="inputAddress" class="col-form-label">
                                                {{$t('string.msg.product.brand.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.firstName" readonly class="form-control" >
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.lastname')}}
                                            </label>
                                            <input type="text" v-model="data.lastName" readonly class="form-control" >
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        
                                        <div class="form-group col-md-3">
                                             <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.gender')}}
                                            </label>
                                            <input type="text" readonly v-model="data.customerUser.gender" class="form-control">
                                         </div>
                                            
                                        <div class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.rg')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.rg" readonly class="form-control" v-mask="['###########']" >
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.cpf')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.document" readonly class="form-control" v-mask="['###.###.###-##']">
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.phone')}}
                                            </label>
                                            <input type="text" v-model="data.primaryPhone" class="form-control" readonly  v-mask="['(##) ####-####', '(##) #####-####']">
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.birthday')}}
                                            </label>
                                             <input type="text" v-model="data.customerUser.dateBirth" class="form-control"  readonly >
                                        </div>
                                        <div class="form-group col-md-9">
                                            <label class="col-form-label">
                                                {{$t('string.msg.trucker.label.email')}}
                                            </label>
                                            <input type="text" v-model="data.email" class="form-control" readonly>
                                        </div>
                                    </div>
                                   <div class="form-row">
                                        <div class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.cnh')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.cnh" class="form-control" v-mask="['############']" readonly>
                                        </div>

                                         <div class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.obs')}}
                                            </label>
                                            <input type="text" v-model="data.customerUser.obsCNH" class="form-control" readonly>
                                        </div>
                                         <div class="form-group col-md-6">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.trucker.label.cnh-attachment')}}
                                            </label>
                                            <input type="file" accept="image/png, image/jpeg" class="form-control">
                                        </div>
                                   </div>
                                   <br>
                                   <div class="form-row">
                                       <div class="form-group col-md-6">
                                             <label class="col-form-label">
                                                {{$t('string.msg.approve.label.company')}}
                                            </label>
                                            <input v-model="data.fantasyName" class="form-control" readonly> 
                                        </div>
                                   </div>
                                   <br/>
                                   <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                            <button v-on:click="confirmArchive" class="btn btn-danger w-20">{{$t('string.msg.approve.label.approved')}}</button>

                                   </div>
                                   <br/>
                                   <div v-if="errors.length" class="alert alert-danger">
                                        <p class="lead">{{$t('response.msg.error.empty.fields')}}</p>
                                        <ul>
                                            <li v-bind:key="error" v-for="error in errors">{{ error }}</li>
                                        </ul>
                                   </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <List v-on:load-item="selectItem"/>
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
        <Confirmation :title="titleToast" :message="messageToast" :cancelText="cancelText" :yesText="yesText" v-on:confirmation-return="archive"/>
    </div>
</template>

<script>
import List from './ListTrucker';
import Controller from './CrtTrucker';
import Datepicker from 'vuejs-datepicker';
import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';
import Confirmation from '../../../components/layout/Confirmation';
import {ptBR,es} from 'vuejs-datepicker/dist/locale'

let maxDate = new Date();
maxDate.setMonth(maxDate.getMonth() + 3);

export default {
  name: 'Trucker',
  components: {
    Spinner,
    Toast,
    List,
    Datepicker,
    Controller,
    Confirmation
  },
  data() {
      return {
        errors: [],
         disabledDates: {
            to: new Date(), // Disable all dates up to specific date,
            from: maxDate, // Disable all dates after specific date
        },
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        companies:[],
        ptBR: ptBR,
        data: {
            firstName: null,
            lastName: null,
            email: null,
            password: null,
            primaryPhone: null,
            secundaryPhone: null,
            type: "USER-CUSTOMER",
            customerUser: {
                subtype: "TRUCK_DRIVER",
                dateBirth: null,
                document: null,
                cnh: null,
                rg: null,
                obsCNH: null,
                cnhPhotoURL: "xxx",
                selfiePhotoURL: "xxx",
                gender: null,
                company:{
                fantasyName: null,
                },
            }
        }
    }
  },
  methods: Controller.methods,
  created() {
         Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
